import { getBreakpoints } from './viewport/getBreakpoints';
import { getViewportType } from './viewport/getViewportType.js';

import type { ViewportType } from './viewport/getViewportType.js';

/**
 * Returns current viewport width in pixels.
 */
function getCurrentViewportWidth(): number {
  return window.innerWidth;
}

/**
 * Returns current viewport type based on window width and breakpoints read from document styles.
 */
function getCurrentViewportType(): ViewportType {
  return getViewportType(getCurrentViewportWidth(), getBreakpoints());
}

export { getCurrentViewportType, getCurrentViewportWidth };
